import {
  Button,
  FormControlLabel,
  FormGroup,
  Grid,
  Switch,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import {Box} from "@mui/system";
import React, {SyntheticEvent, useEffect, useState} from "react";
import {Controller, SubmitHandler, useForm} from "react-hook-form";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {useSetRecoilState} from "recoil";
import {
  isAuthState,
  levelState,
  tokenState,
  userCompanyData,
  userState,
} from "../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../Recoil/Atom/snackBarState";
import * as loginApi from "../api/userApi/userApi";
import {useAuthMutation} from "../hooks/useQueryHooks";
import {ResponseAuth} from "../models/clientModels/interfaces/Response";
import * as Params from "../models/clientModels/interfaces/apiParams";
import {EQUser} from "../models/serverModels/EQUser";

import axios from "axios";
import factoryImg from "../temp/factory3.png";
import MWProgress from "../components/MWProgress";

const StyledLoginContainer = styled(Grid)(
  ({theme}) => `
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100vh;
  overflow: hidden;
   video {
    position: absolute;
    width: 100%;
   }
 
`
);

const StyledLoginContent = styled(Box)(
  ({theme}) => `
    color: rgba(0, 0, 0, 0.87);
    transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow-wrap: break-word;
    background-color: rgb(255, 255, 255);
    background-clip: border-box;
    border: 0px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.75rem;
    box-shadow: rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem;
    overflow: visible;
`
);
const StyledLoginHeader = styled(Box)(
  ({theme}) => `
    width: 90%;
    margin: -48px 16px 8px;
    padding: 16px;
    text-align: center;
    opacity: 1;
    background: linear-gradient(195deg, rgb(73, 163, 241), rgb(26, 115, 232));
    color: rgb(52, 71, 103);
    border-radius: 0.5rem;
    box-shadow: rgb(0 0 0 / 14%) 0rem 0.25rem 1.25rem 0rem, rgb(0 187 212 / 40%) 0rem 0.4375rem 0.625rem -0.3125rem;

    h4 {
      margin: 8px 0px 16px 0px;
    font-size: 1.5rem;
    line-height: 1.375;
    font-family: Roboto, Helvetica, Arial, sans-serif;
    letter-spacing: 0.00735em;
    opacity: 1;
    text-transform: none;
    vertical-align: unset;
    text-decoration: none;
    color: rgb(255, 255, 255);
    font-weight: 600;
}
    img {
      width: 100%;
      height: 100%;
      border-radius: 6px;
    }
}
`
);

const StyledFormContainer = styled(Box)(
  ({theme}) => `
  width: 100%;
  padding: 32px 24px 24px 24px;
  opacity: 1;
  background: transparent;
  color: rgb(52, 71, 103);
  box-shadow: none;

  input {
    width: 100%;
  }
  button {
    width: 100%;
  }
`
);

const Login = () => {
  const location = useLocation();

  const [searchParams] = useSearchParams();
  const l1 = searchParams.get("l1");
  const l2 = searchParams.get("l2");
  const l3 = searchParams.get("l3");

  const navigate = useNavigate();

  const [remember, setRemember] = useState<boolean>(false);
  const [logo, setLogo] = useState("");
  const [company, setCompany] = useState("");

  const setTokenSate = useSetRecoilState(tokenState);
  const setIsAuth = useSetRecoilState(isAuthState);
  const setLevelSate = useSetRecoilState(levelState);
  const setUserSate = useSetRecoilState(userState);
  const setCompanyData = useSetRecoilState(userCompanyData);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {
    mutateAsync: authMutate,
    isLoading,
    isSuccess,
    data,
  } = useAuthMutation<ResponseAuth<EQUser>, Params.Auth>({
    api: loginApi.login,
    options: {
      onSuccess: (data: ResponseAuth<EQUser>) => {
        if (data.isAuth) {
          setTokenSate(data?.item?.token!);
          setIsAuth(data.isAuth);
          setUserSate(data?.item!);

          setLevelSate(data.item?.userLevel!);
          setCompanyData(data.item?.company?.companyData!);
          setSnackBarToggle(true);
          setSnackBarState("login");
          // navigate(data.item?.l1 ? `/${data.item?.l1}/${data.item?.l2}` : "/Home/DashBoard");
          let url = `/${l1}`;
          if (l2) url += `/${l2}`;
          if (l3) url += `/${l3}`;
          navigate(l1 ? url : "/Home/DashBoard");
        }
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const logoImage = () => {
    axios({
      method: "get",
      url: "/API/GetCompanyImage",
    }).then((result) => {
      setLogo(result.data.split(":")[0]);
      setCompany(result.data.split(":")[1]);
    });
  };

  const onErrorImg = (event: SyntheticEvent<HTMLImageElement, Event>) => {
    event.currentTarget.src = factoryImg;
  };

  const {
    handleSubmit,
    control,
    getValues,
    formState: {errors},
  } = useForm<EQUser>({
    defaultValues: {
      loginID: localStorage.getItem("loginID") || "",
      loginPW: localStorage.getItem("loginPW") || "",
    },
  });

  const onSubmit: SubmitHandler<EQUser> = async (data) => {
    await authMutate({
      id: data.loginID,
      pw: data.loginPW,
      l1,
      l2,
    });

    if (remember) {
      localStorage.setItem("loginID", getValues("loginID"));
      localStorage.setItem("loginPW", getValues("loginPW"));
    } else {
      localStorage.clear();
    }
  };

  useEffect(() => {
    (localStorage.getItem("loginID") || localStorage.getItem("loginPW")) && setRemember(true);
    logoImage();
  }, []);

  return (
    <React.Fragment>
      <StyledLoginContainer container>
        <video autoPlay loop playsInline muted>
          <source src="/videos/bg_movie.mp4" type="video/mp4" />
        </video>
        {isLoading && <MWProgress />}
        <Grid
          item
          xs={12}
          sm={10}
          md={4}
          lg={3}
          sx={{marginLeft: {lg: "30%", md: "30%", sm: "0%", xs: "0%"}}}
        >
          <StyledLoginContent>
            <StyledLoginHeader>
              <Typography variant="h4">{company}</Typography>
              <img
                src={process.env.REACT_APP_PATH_COMPANY_LOGO + logo}
                onError={onErrorImg}
                alt="업체 로고"
              />
            </StyledLoginHeader>
            <StyledFormContainer>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Controller
                  name="loginID"
                  control={control}
                  render={({field}) => (
                    <Box>
                      <TextField
                        {...field}
                        style={{backgroundColor: "#fff"}}
                        id="loginID"
                        size="small"
                        required
                        label="ID"
                        autoFocus
                        sx={{width: "100%"}}
                      />
                      <Typography>{errors.loginID?.message}</Typography>
                    </Box>
                  )}
                />
                <Controller
                  name="loginPW"
                  control={control}
                  render={({field}) => (
                    <div>
                      <TextField
                        {...field}
                        style={{backgroundColor: "#fff"}}
                        id="loginPW"
                        type="password"
                        size="small"
                        required
                        label="Password"
                        margin="normal"
                        sx={{width: "100%"}}
                      />
                      <Typography>{errors.loginPW?.message}</Typography>
                    </div>
                  )}
                />
                {isSuccess && !data?.isAuth && (
                  <span style={{fontSize: "14px", color: "red"}}>
                    아이디 또는 비밀번호을 다시 확인해주세요.
                  </span>
                )}
                <FormGroup>
                  <FormControlLabel
                    sx={{
                      marginBottom: "36px",
                      ".MuiFormControlLabel-label": {
                        fontSize: 14,
                        fontWeight: "600",
                      },
                    }}
                    control={
                      <Switch
                        checked={remember}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                          setRemember(event?.target.checked)
                        }
                      />
                    }
                    label="아이디/비번 기억하기"
                  />
                </FormGroup>
                <Button type="submit" variant="contained" color="primary" size="large">
                  로그 인
                </Button>
                <div>
                  <p style={{fontSize: "14px", fontWeight: "bold"}}>특허 제 10-2577203호</p>
                  <span style={{fontSize: "13px"}}>
                    COPYRIGHT (C) 2024 KOREA INDUSTRIAL SAFETY ASSOCIATION. ALL RIGHTS RESERVED
                  </span>
                </div>
              </form>
            </StyledFormContainer>
          </StyledLoginContent>
        </Grid>
      </StyledLoginContainer>
    </React.Fragment>
  );
};
export default Login;
